import { Lang } from "config/i18n/languages";
import { resolveLang } from "hooks/useLang";
import { htmlLang } from "config/i18n/languages";

// Hosts that serve the site in one language only (no language menu).
// www2.marksim.org: English-only preview (2026-10-05).
const FORCED_LANG_BY_HOST: Record<string, Lang> = {
  "www2.marksim.org": "en",
};

export const FORCED_LANG: Lang | null =
  typeof window !== "undefined"
    ? FORCED_LANG_BY_HOST[window.location.hostname] || null
    : null;

/** Call once before the first render: every component resolves its language
 *  from sessionStorage.lang, so pinning it there switches the whole site. */
export const applyForcedLang = () => {
  if (!FORCED_LANG) {
    document.documentElement.lang = htmlLang(resolveLang());
    return;
  }
  try {
    sessionStorage.setItem("lang", FORCED_LANG);
  } catch {
    /* storage blocked: components fall back to navigator.language */
  }
  document.documentElement.lang = FORCED_LANG;
};
